import React from 'react';
import useStyles from './styles';
import { Button } from '@mui/material';
import { ModalContent } from './modalContent';
import { SimpleModal, Icon } from '@livable/saas-react-components';
export const DismissRefundModal = _ref => {
  let stripeRefundId = _ref.stripeRefundId,
    reloadData = _ref.reloadData;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    title: "Dismiss refund",
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionIcon",
      size: "small",
      className: classes.trigger
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "error"
    })),
    noPadding: true
  }, /*#__PURE__*/React.createElement(ModalContent, {
    stripeRefundId: stripeRefundId,
    reloadData: reloadData
  }));
};